// extracted by mini-css-extract-plugin
module.exports = {"comp":"BlackA_comp__IWXtP","title":"BlackA_title__wu5qc"};